import { funcModal } from 'components/modals'

const components = {
    funcModal
}

const methods = {
    open (reservation, amount, currency_code, actionType = 'check-out') {
        this.type = "without_charge";
        this.reservation = reservation;
        this.amount = amount;
        this.currency_code = currency_code;
        this.actionType = actionType;
        this.$refs.modal.open();
    },

    onClose () {
        this.$emit('close');
    },

    submit () {
        this.$emit("update-processing", true);
        this.$emit('update-reservation', this.type, this.reservation);
        this.$refs.modal.close();
    },
}

const computed = {
    modalTitle () {
        return this.actionType === 'check-in' ? 'Early Check-in Fee' : 'Late Checkout Fee';
    },

    chargeDescription () {
        return this.actionType === 'check-in'
            ? `Would you like to charge the customer ${this.currency_code + this.amount} for early check-in?`
            : `Would you like to charge the customer ${this.currency_code + this.amount} for late checkout?`;
    },
}

export default {
    name: 'confirm-extend-reservation-modal',
    props: ['checkout_processing'],
    methods,
    computed,
    components,
    data () {
        return {
            reservation: null,
            amount: 0,
            currency_code: null,
            type: "without_charge",
            actionType: 'check-out',
        }
    }
}